import React from 'react'

import { bool } from 'prop-types'

import RedesignedOverviewTab from './RedesignedOverviewTab'

function OverviewTab({ isSubscriptionParticipant = false }) {
  return <RedesignedOverviewTab isSubscriptionParticipant={isSubscriptionParticipant} />
}

OverviewTab.propTypes = {
  isSubscriptionParticipant: bool,
}

export default OverviewTab
